<template>
  <div class="pa-4">
    <div class="mb-2">Try one of these starters:</div>
    <v-chip small class="mr-2 mb-2" @click="$emit('prompt', 'Brainstorm 10 ideas about ')">Brainstorm 10</v-chip>
    <v-chip small class="mr-2 mb-2" @click="$emit('prompt', 'Give 3 directions to improve this idea: ')">Improve</v-chip>
    <v-chip small class="mr-2 mb-2" @click="$emit('prompt', 'Turn this into a kid-friendly project with steps: ')">Project steps</v-chip>
  </div>
</template>

<script>
export default { name: 'IdeaBrainstorm' }
</script>


